import "./cartitem.css";
import { GoThreeBars } from "react-icons/go";
import { useEffect, useRef, useState } from "react";
import Child from "./Child";
import { compact, repeat, uniq } from "lodash";

export default function Cartitem({ itemArray }) {
  return (
    <>
      {itemArray.map((it, ind) => {
        return (
          <div className="container">
            <div>
              <img alt="img" src={it.image} height={80} width={80} />
            </div>
            <div className="titlePrice">
              <span>{it.title}</span>
              <b>{it.price}</b>
            </div>
          </div>
        );
      })}
    </>
  );
}
